import { getBusinessObject } from "bpmn-js/lib/util/ModelUtil";

export default {
  isNotPassEndEvent(endEvent) {
    return (
      this.getExtensionAttributeValue(endEvent, "endEventType") === "not_pass"
    );
  },
  getSequenceFlowType(sequenceFlow) {
    return this.getExtensionAttributeValue(sequenceFlow, "sequenceFlowType");
  },
  getExtensionAttributeValue(element, attributeName) {
    const extensionAttributes = this.getExtensionAttributes(
      getBusinessObject(element)
    );
    const item = extensionAttributes.filter((e) => e.id === attributeName)[0];
    if (item) {
      return item.value;
    }
    return null;
  },
  getExtensionAttributes(element) {
    return this.getExtensionProperties(element, "extensionAttributes");
  },
  getExtensionProperties(element, id) {
    const businessObject = getBusinessObject(element);
    const extensionElements = businessObject.extensionElements;
    if (
      !extensionElements ||
      !extensionElements.values ||
      !extensionElements.values.length
    ) {
      return [];
    }
    const extensionProperties = extensionElements.values.filter(
      (e) => e.$type === "activiti:properties" && e.id === id
    )[0];
    if (
      !extensionProperties ||
      !extensionProperties.$children ||
      !extensionProperties.$children.length
    ) {
      return [];
    }
    return extensionProperties.$children;
  },
};
